module.exports = __webpack_public_path__ + "img/n1.a778b233.png";